import { createFileRoute } from '@tanstack/react-router';
import { ManageCampaignsPage } from '@/pages/member-portal/campaigns/ManageCampaignsPage';

function MemberPortalManageCampaignsRoute() {
	return <ManageCampaignsPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/campaigns')({
	component: MemberPortalManageCampaignsRoute,
});
